import { render, staticRenderFns } from "./MaintenanceView.vue?vue&type=template&id=497c6c34"
var script = {}
import style0 from "./MaintenanceView.vue?vue&type=style&index=0&id=497c6c34&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports